import PropertyListerView from '../view'

export default class PropertyListView extends PropertyListerView {
    
    constructor(controller) {
        super(controller)
    }
}
